module.exports = __webpack_public_path__ + "static/media/salary.01c3baad.svg";